<script setup lang="ts">
import { computed } from 'vue'
import Card from '@uiKit/components/Card.vue'
import Message from '@uiKit/elements/Message.vue'
import PortfolioStatusTiles from '../components/list/PortfolioStatusTiles.vue'
import { usePortfolioStatusQuery } from '../api/usePortfolioStatusQuery'

// Smart container for the Portfolio Status card. Owns its own query rather than
// deriving from the list: the counts are computed server-side over the whole
// portfolio, so a tile must not change when the seller turns the page.
const query = usePortfolioStatusQuery()

const status = computed(() => query.data.value ?? null)
const isLoading = computed(() => query.isPending.value)
const errorMessage = computed(() =>
  query.isError.value ? 'Could not load your portfolio status.' : '',
)
</script>

<template>
  <Card variant="outlined" padding="6">
    <Message v-if="errorMessage" color="danger" variant="outlined">{{ errorMessage }}</Message>
    <PortfolioStatusTiles v-else :status="status" :is-loading="isLoading" />
  </Card>
</template>
